import { render, staticRenderFns } from "./AgreementPersonEdit.vue?vue&type=template&id=6e843a98&scoped=true"
import script from "./AgreementPersonEdit.vue?vue&type=script&lang=js"
export * from "./AgreementPersonEdit.vue?vue&type=script&lang=js"
import style0 from "./AgreementPersonEdit.vue?vue&type=style&index=0&id=6e843a98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e843a98",
  null
  
)

export default component.exports